import { TextBlock } from '../../Atoms/Text';
import { CardButton } from '../Buttons/CardButton';

export interface RecordUnavailableProps {
  message: string;
  actionText?: string;
  onAction?: () => void;
  dataTestId?: string;
}

export const RecordUnavailable = ({ message, actionText, onAction, dataTestId }: RecordUnavailableProps) => (
  <div
    className="flex flex-col items-center py-12 text-center"
    data-testid={dataTestId}>
    {/* A live region, because this replaces a spinner in place — scoped to the text, which is what it announces. */}
    <div role="status">
      <TextBlock color="grey6">{message}</TextBlock>
    </div>
    {actionText && onAction && (
      <CardButton
        text={actionText}
        onClick={onAction}
        className="mt-4 h-8 pl-4 pr-2 border border-grey-2 rounded-lg shadow"
      />
    )}
  </div>
);
